import React, { useEffect, useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Tooltip, Icon, Divider } from '@mui/material';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import AptaTable from 'examples/AptaTable';
import axios from 'axios';
import { SERVER_URL } from 'constants/constant';
import moment from 'moment';

function Reviews() {
    const [reviews, setReviews] = useState([]);
    const [open, setOpen] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);

    useEffect(() => {
        fetchReviews();
    }, []);

    async function fetchReviews() {
        try {
            const response = await axios.get(`${SERVER_URL}/get-all-payments`);
            if (response.status === 200) {
                setReviews(response.data.data?.allPayments?.reverse());
            } else {
                console.error('Unexpected response code:', response.status);
            }
        } catch (error) {
            console.error('Error fetching reviews:', error);
        }
    }

    const handleOpen = (review) => {
        setCurrentItem(review);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCurrentItem(null);
    };


    return (
        <DashboardLayout>
            <DashboardNavbar />
            <AptaTable
                columns={['Name', 'Email', 'Phone', 'Amount', 'Status', 'Date', 'Actions']}
                rows={reviews?.map((review) => ({
                    Name: `${review?.firstName || 'N/A'} ${review?.lastName || ''}`,
                    Email: review?.email || 'N/A',
                    Phone: review?.phoneNumber || 'N/A',
                    Amount: `₹${review?.amount || '0'}`,
                    Status: review?.status || 'N/A',
                    Date: moment(review?.date).format('MMMM Do YYYY, h:mm A') || 'N/A',
                    Actions: (
                        <Button
                            variant="contained"
                            onClick={() => handleOpen(review)} style={{ color: "white" }}
                        >
                            <Icon>visibility</Icon>
                        </Button>

                    )
                }))}
            />

            {/* Modal for showing full details */}
            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>Payment Details</DialogTitle>
                <DialogContent>
                    {currentItem && (
                        <Box>
                            <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '10px' }}>User Information</Typography>
                            <Divider sx={{ marginBottom: '10px' }} />
                            <Typography><strong>Name:</strong> {currentItem.firstName} {currentItem.lastName}</Typography>
                            <Typography><strong>Email:</strong> {currentItem.email}</Typography>
                            <Typography><strong>Phone:</strong> {currentItem.phoneNumber}</Typography>
                            <Typography variant="h6" sx={{ fontWeight: 'bold', marginTop: '20px', marginBottom: '10px' }}>Payment Details</Typography>
                            <Divider sx={{ marginBottom: '10px' }} />
                            <Typography><strong>Amount:</strong> ₹{currentItem.amount}</Typography>
                            <Typography><strong>Status:</strong> {currentItem.status}</Typography>
                            <Typography><strong>Date:</strong> {moment(currentItem.date).format('MMMM Do YYYY, h:mm A')}</Typography>
                            <Typography><strong>Order ID:</strong> {currentItem.orderId}</Typography>
                            <Typography variant="h6" sx={{ fontWeight: 'bold', marginTop: '20px', marginBottom: '10px' }}>Additional Details</Typography>
                            <Divider sx={{ marginBottom: '10px' }} />
                            <Typography><strong>Category:</strong> {currentItem.userId?.category}</Typography>
                            <Typography><strong>Institute:</strong> {currentItem.userId?.institute}</Typography>
                            <Typography><strong>Address:</strong> {currentItem.userId?.address}, {currentItem.userId?.city}, {currentItem.userId?.state}, {currentItem.userId?.country}, {currentItem.userId?.pincode}</Typography>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="secondary">Close</Button>
                </DialogActions>
            </Dialog>
        </DashboardLayout>
    );
}

export default Reviews;